<template>
  <div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-50 flex items-center justify-center mt-5 overflow-x-hidden overflow-y-auto outline-none md:mt-5 focus:outline-none"
    >
      <div class="relative w-[50rem] h-full p-4 md:h-auto">
        <div class="relative bg-white shadow rounded-xl">
          <div class="flex items-center justify-between px-2 py-4">
            <p class="pl-2 font-medium text-black">Welcome to Hutloop</p>
            <button
              type="button"
              class="absolute right-0 flex items-center justify-center p-1 ml-auto text-sm font-thin text-black bg-transparent bg-gray-200 rounded-full w-14 hover:text-gray-900"
              @click="closeViewModal()"
              data-modal-toggle="show-login-modal"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <hr />

          <div class="flex md:flex-row md:h-[25rem] flex-col">
            <!-- Login form -->
            <div v-if="modalType === 'login'" class="hidden md:w-6/12 md:flex">
              <img
                src="@/assets/images/login-register.jpg"
                class="w-full h-full rounded-bl-xl"
                alt=""
              />
              <!-- <p
                class="flex items-center justify-center mt-5 text-sm font-light text-center text-gray-500"
              >
                View saved properties <br />

                See which properties you have contacted
              </p> -->
            </div>
            <div
              v-if="modalType === 'login'"
              class="flex flex-col items-center justify-center p-6 space-y-5 md:w-6/12"
            >
              <div
                class="text-sm"
                v-if="state.message.content"
                :class="messageClass"
              >
                {{ state.message.content }}
              </div>
              <input
                type="email"
                class="w-full p-2 text-sm text-black border border-gray-400 rounded-lg h-11 placeholder:text-stone-400"
                placeholder="Email"
                v-model="email"
                id="login_email"
              />
              <input
                type="password"
                class="w-full p-2 text-sm border border-gray-400 rounded-lg h-11 placeholder:text-stone-400"
                placeholder="password"
                v-model="password"
                id="login_password"
              />
              <button
                @click="handleLogin"
                :class="[
                  'w-full p-3 mt-5 font-semibold text-white rounded-lg',
                  loading
                    ? 'bg-gray-300 cursor-not-allowed'
                    : 'bg-primary hover:bg-secondary',
                ]"
                :disabled="loading"
              >
                Login
              </button>
              <p v-if="loading" class="mt-5 text-xs text-center text-primary">
                Logging in...
              </p>
              <p class="mt-5 text-xs text-center">
                <a
                  href="#"
                  class="text-primary"
                  @click.prevent="switchModalType('forgot-password')"
                  >Forgot Password?</a
                >
              </p>
              <p class="mt-5 text-xs text-center">
                Don't have an account?
                <a
                  href="#"
                  class="text-primary"
                  @click.prevent="switchModalType('register')"
                  >Register</a
                >
              </p>
              <p class="mt-5 text-xs text-center">
                By registering you accept our
                <a href="" class="text-primary">Terms & Conditions</a> and
                <a href="" class="text-primary"> our privacy policy.</a>
              </p>
            </div>

            <!-- Register form -->
            <div
              v-if="modalType === 'register'"
              class="hidden md:w-6/12 md:flex"
            >
              <img
                src="@/assets/images/login-register.jpg"
                class="w-full h-full rounded-bl-xl"
                alt=""
              />
              <!-- <p
                class="flex items-center justify-center mt-5 text-sm font-light text-center text-gray-500"
              >
                View saved properties <br />

                See which properties you have contacted
              </p> -->
            </div>
            <div
              v-if="modalType === 'register'"
              class="flex flex-col items-center justify-center p-6 space-y-5 md:w-6/12"
            >
              <div
                class="text-sm"
                v-if="state.message.content"
                :class="messageClass"
              >
                {{ state.message.content }}
              </div>
              <input
                type="text"
                class="w-full p-2 text-sm text-black border border-gray-400 rounded-lg h-11 placeholder:text-stone-400"
                placeholder="Full Name"
                v-model="full_name"
                id="register_name"
              />
              <input
                type="email"
                class="w-full p-2 text-sm text-black border border-gray-400 rounded-lg h-11 placeholder:text-stone-400"
                placeholder="Email"
                v-model="email"
                id="register_email"
              />
              <input
                type="password"
                class="w-full p-2 text-sm border border-gray-400 rounded-lg h-11 placeholder:text-stone-400"
                placeholder="Password"
                v-model="password"
                id="register_password"
              />
              <button
                @click="handleRegister"
                :class="[
                  'w-full p-3 mt-5 font-semibold text-white rounded-lg',
                  loading
                    ? 'bg-gray-300 cursor-not-allowed'
                    : 'bg-primary hover:bg-secondary',
                ]"
                :disabled="loading"
              >
                Register
              </button>
              <p v-if="loading" class="mt-5 text-xs text-center text-primary">
                Registering...
              </p>
              <p v-else class="mt-5 text-xs text-center">
                Already have an account?
                <a
                  href="#"
                  class="text-primary"
                  @click.prevent="switchModalType('login')"
                  >Log in</a
                >
              </p>
              <p class="mt-5 text-xs text-center">
                By registering you accept our
                <a
                  :href="
                    $router.resolve({
                      name: 'FooterPages',
                      params: {
                        slug: 'terms-conditions',
                      },
                    }).href
                  "
                  class="text-primary"
                  >Terms & Conditions</a
                >
                and
                <a
                  :href="
                    $router.resolve({
                      name: 'FooterPages',
                      params: {
                        slug: 'privacy-policy',
                      },
                    }).href
                  "
                  class="text-primary"
                >
                  our privacy policy.</a
                >
              </p>
            </div>

            <!-- Forgot Password form -->
            <div
              v-if="modalType === 'forgot-password'"
              class="hidden md:flex md:w-6/12"
            >
              <img
                src="@/assets/images/login-register.jpg"
                class="w-full h-full rounded-bl-xl"
                alt=""
              />
            </div>
            <div
              v-if="modalType === 'forgot-password'"
              class="flex flex-col items-center justify-center p-6 space-y-5 md:w-6/12"
            >
              <div
                class="text-sm"
                v-if="state.message.content"
                :class="messageClass"
              >
                {{ state.message.content }}
              </div>
              <input
                type="email"
                class="w-full p-2 text-sm text-black border border-gray-400 rounded-lg h-11 placeholder:text-stone-400"
                placeholder="Email"
                v-model="email"
                id="forgot_password_email"
              />
              <button
                @click="handleForgotPassword"
                :class="[
                  'w-full p-3 mt-5 font-semibold text-white rounded-lg',
                  loading
                    ? 'bg-gray-300 cursor-not-allowed'
                    : 'bg-primary hover:bg-secondary',
                ]"
                :disabled="loading"
              >
                Send Reset Link
              </button>
              <p v-if="loading" class="mt-5 text-xs text-center text-primary">
                Sending reset link...
              </p>
              <p v-else class="mt-5 text-xs text-center">
                Remembered your password?
                <a
                  href="#"
                  class="text-primary"
                  @click.prevent="switchModalType('login')"
                  >Log in</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-40 bg-black opacity-25"
    ></div>
  </div>
</template>

<script setup>
import { getCurrentInstance, defineProps, ref, computed } from "vue";
import useAuth from "@/composables/useAuth";

const { emit } = getCurrentInstance();
defineProps({
  showViewModal: Boolean,
  modalType: {
    type: String,
    required: true,
  },
});

const { state, login, register, forgotPassword } = useAuth();

const messageClass = computed(() => {
  return state.message.type === "success" ? "text-green-500" : "text-red-500";
});

const email = ref("");
const password = ref("");
const full_name = ref("");
const loading = ref(false);

const handleLogin = async () => {
  loading.value = true;
  try {
    await login(email.value, password.value);
    if (state.isAuthenticated) {
      setTimeout(() => {
        closeViewModal();
        location.reload(true);
      }, 1000);
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const handleRegister = async () => {
  loading.value = true;
  try {
    await register(full_name.value, email.value, password.value);
    if (state.isAuthenticated) {
      closeViewModal();
      window.location.reload();
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const handleForgotPassword = async () => {
  loading.value = true;
  try {
    await forgotPassword(email.value);
    setTimeout(() => {
      closeViewModal();
    }, 1000);
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const closeViewModal = () => {
  emit("closeViewModal");
};

const switchModalType = (type) => {
  emit("switchModalType", type);
};
</script>

<style scoped>
.text-green-500 {
  color: #10b981; /* Tailwind green-500 */
}
.text-red-500 {
  color: #ef4444; /* Tailwind red-500 */
}
</style>
